import React from 'react'
import hoistNonReactStatics from 'hoist-non-react-statics'
import { ReactReduxContext } from 'react-redux'

import getInjectors from './reducerInjectors'

export default ({ key, reducer, dynamic = false }) => WrappedComponent => {
  class ReducerInjector extends React.Component {
    static WrappedComponent = WrappedComponent
    static contextType = ReactReduxContext
    static displayName = `withReducer(${WrappedComponent.displayName ||
      WrappedComponent.name ||
      'Component'})`

    constructor(props, context) {
      super(props, context)
      const args = dynamic ? [props.reducerKey, props.reducer] : [key, reducer]
      getInjectors(context.store).injectReducer(...args)
    }

    render() {
      const { reducer, reducerKey, forwardedRef, ...props } = this.props
      return <WrappedComponent ref={forwardedRef} {...props} />
    }
  }
  const ForwardedComponent = React.forwardRef((props, ref) => {
    return <ReducerInjector {...props} forwardedRef={ref} />
  })

  return hoistNonReactStatics(ForwardedComponent, WrappedComponent)
}

const useInjectReducer = ({ key, reducer }) => {
  const context = React.useContext(ReactReduxContext)
  React.useEffect(() => {
    getInjectors(context.store).injectReducer(key, reducer)
  }, [context.store, key, reducer])
}

export { useInjectReducer }
